export const BOOK_DEMO_URL =
  "https://www.talentlms.com/getdemo?utm_source=site&utm_medium=internal&utm_campaign=premium_trial";
